import React, { Component } from 'react';
import './styles.scss';
import { connect } from 'react-redux';
import { simpleAction } from '../../core/actions/homeAction';
import { withTranslation } from "react-i18next";
import i18n from '../../core/helpers/i18n';
import { compose } from 'redux';

import functionCommon from '../../core/common/function';

import ProjectTable from '../../components/ProjectTable';

class HomePage extends Component {

    constructor() {
        super();
        this.state = {
            tableStructure: [
                {
                    label: 'labels.id',
                    type: 'id',
                    isClass: 'example-class'
                },
                {
                    label: 'labels.employeeCode',
                    type: 'employeeCode',
                    sort: true
                },
                {
                    label: 'labels.nickName',
                    type: 'nickName'
                },
                {
                    label: 'labels.firstName',
                    type: 'firstName'
                },
                {
                    label: 'labels.lastName',
                    type: 'lastName'
                },
                {
                    label: 'labels.position',
                    type: 'positionCode',
                    subType: 'employeePosition',
                    isValueInArray: false,
                    sort: true
                },
                {
                    label: 'labels.department',
                    type: 'departmentName',
                    subType: 'employeePosition',
                    isValueInArray: false,
                    sort: true
                },
                {
                    label: 'labels.billable',
                    type: 'billable',
                    isCheckbox: true
                },
                {
                    label: 'labels.status',
                    type: 'status',
                    isChangeText: true,
                    arrayTextChange: {
                        '0': 'labels.working',
                        '1': 'labels.nonWorking'
                    }

                }
            ]
        }
    }

    simpleAction = (event) => {
        this.props.simpleAction();
    }

    changeLanguage = (lng) => {
        localStorage.removeItem('lng');
        localStorage.setItem('lng', lng);
        i18n.changeLanguage(lng);
    }

    clickClick = (event) => {
        console.log(functionCommon.checkRequestApiTime());
    }

    onRowClick = (val) => {
        console.log(val);
    }

    render() {
        return (
            <div>
                <ProjectTable
                    tableStructure={this.state.tableStructure}
                    dataList={this.props.employeeReducer.dataEmployee}
                    onRowClick={(val) => this.onRowClick(val)}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    ...state,
})

const mapDispatchToProps = dispatch => ({
    simpleAction: () => dispatch(simpleAction())
})

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(HomePage);
